import { combineReducers } from "redux";

import { reducer as form } from "redux-form";

import app from "./appReducer";
import request from "./requestReducer";
import resource from "./resourceReducer";
import active from "./activeReducer";
import dialog from "./dialogReducer";
import searchBar from "./searchBarReducer"
import canUserEditThisOrganization from "./canUserEditThisOrganizationReducer"

export default combineReducers({
  form,
  app,
  request,
  resource,
  active,
  dialog,
  searchBar,
  canUserEditThisOrganization
});



// WEBPACK FOOTER //
// ./src/reducers/index.js